import { useState, useEffect, useCallback } from 'react';

/**
 * Спільний стан шапки «Перелік СЕС» (/assets) — РЕДИЗАЙН.
 *
 * Пошук і фільтр типу винесено в топбар за §6 дизайн-контракту. Фільтрація
 * лишається клієнтською в тілі сторінки — сюди їдуть лише значення контролів.
 *
 * Прийом той самий, що useMarketPricesUi / useTradingUi / useSaleTermsUi:
 * модульний state + CustomEvent-синхронізація в межах вкладки.
 */
const EV = 'helios:assets-ui-change';

const state = { search: '' as string, type: '' as string };

const emit = () => window.dispatchEvent(new CustomEvent(EV));

export function useAssetsUi() {
  const [, force] = useState(0);
  useEffect(() => {
    const refresh = () => force((x) => x + 1);
    window.addEventListener(EV, refresh);
    return () => window.removeEventListener(EV, refresh);
  }, []);

  const setSearch = useCallback((v: string) => { if (state.search !== v) { state.search = v; emit(); } }, []);
  const setType = useCallback((v: string) => { if (state.type !== v) { state.type = v; emit(); } }, []);

  return { search: state.search, type: state.type, setSearch, setType };
}

/** Порядок типів у фільтрі; підписи — через i18n-ключі asset_type_*. */
export const ASSET_TYPES = ['solar', 'wind', 'bess', 'hybrid', 'consumer_site'] as const;
